/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'cubata': {
    width: 60,
    height: 60,
    viewBox: '0 0 60 60',
    data: '<path pid="0" d="M30 21c3.866 0 7-1.12 7-2.5S33.866 16 30 16s-7 1.12-7 2.5 3.134 2.5 7 2.5zM37 25.5c0 1.381-3.134 2.5-7 2.5s-7-1.119-7-2.5" _stroke="#000" stroke-width="2" stroke-miterlimit="10"/><path pid="1" d="M37 18.5v36c0 1.381-3.134 2.5-7 2.5-1.017 0-7 0-7-2.5M23 18.5v36M22 9c3.314 0 6-1.12 6-2.5S25.314 4 22 4s-6 1.12-6 2.5S18.686 9 22 9zM39 8c3.314 0 6-1.12 6-2.5S42.314 3 39 3s-6 1.12-6 2.5S35.686 8 39 8zM45 10.5c0 1.381-2.686 2.5-6 2.5M22 14c-3.314 0-6-1.119-6-2.5M28 6.5v9.604" _stroke="#000" stroke-width="2" stroke-miterlimit="10"/><path pid="2" d="M16 6.5v33.264c0 .758.428 1.451 1.141 1.706 1.282.457 3.407 1.03 5.859 1.03M33 5.5v10.741M45 5.5V40c0 1.5-5 2-7.5 2" _stroke="#000" stroke-width="2" stroke-miterlimit="10"/>'
  }
})
